import { render, staticRenderFns } from "./product-data-list.vue?vue&type=template&id=4bef0aa0&scoped=true&"
import script from "./product-data-list.vue?vue&type=script&lang=js&"
export * from "./product-data-list.vue?vue&type=script&lang=js&"
import style0 from "./product-data-list.vue?vue&type=style&index=0&id=4bef0aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bef0aa0",
  null
  
)

export default component.exports